import React, { useEffect, useState } from 'react'
import RouteModal from '../../../../Component/BasicComponents/Modal/RouteModal';
import ReusableDropdown from '../../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import { Btn } from '../../../../AbstractElements';
import {useAddTerritoryTown, useGetAssign_To_Tripes, useGetLocation, useGetOtersTripTypes, useUpdateTerritoryTown } from '../UseTerriitory';
import PaginatedRouteDropdown from '../../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper';
import { getTownFilter } from '../../../Customer Management/Customer/hooks/CustomerRepository';
import { showToast } from '../../../../utils/toastUtils';

type ProductCardProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    TerritoryId?:number,
    rowData?:any
};
interface ModalDataInterface{
        Town:string | number,
        Assig_To_Trip_Type:string,
        Other_Trip_Type:string,
        Only_NCA:boolean,
}
    const TownAddAndEditModal: React.FC<ProductCardProps> = ({rowData, TerritoryId,setIsModalOpen, isModalOpen, checkAddEditStatus, setCheckAddEditStatus }) => {
         const initialModalData: ModalDataInterface={
            Town:'',
            Assig_To_Trip_Type:'',
            Other_Trip_Type:'',
            Only_NCA:false
        }

    const [ModalData, setModalData] = useState<ModalDataInterface>(initialModalData);
    const [inputSearch,setInputSearch] = useState('');
    const [APISearch,setAPISearh]  = useState('');
    const [isTyping,setIsTyping] = useState(false); 
    const [TownListInitalOption,setTownListInitalOption] = useState<{id:number,label:string} | null>(null);


useEffect(()=>{
    if(checkAddEditStatus ==='Edit'){
         setTownListInitalOption({
            id:rowData.id,
            label:String(rowData.TownEdFilter)
         })
    }
},[checkAddEditStatus])

useEffect(() => {
    if (isTyping && inputSearch !== '') {
    const timer = setTimeout(() => {
      setAPISearh(inputSearch); // ✅ Set search term for API
    },500);
    return () => clearTimeout(timer);
    }
},[inputSearch, isTyping]);

  
useEffect(()=>{
 if(rowData && checkAddEditStatus ==='Edit' && isModalOpen){
    setAPISearh(rowData?.Town);
        setModalData({
            Town:rowData?.id ?? '',
            Assig_To_Trip_Type:rowData?.Assign_To_Trip_Type ?? '',
            Other_Trip_Type:rowData?.Others_Trip_Type ?? '',
            Only_NCA:rowData?.Only_NCA ?? false
        })

    }
    else if(checkAddEditStatus ==='Add' && isModalOpen){
            setModalData(initialModalData)
    }
},[rowData,checkAddEditStatus, isModalOpen])



   const {data:AssignTripData,isLoading:AssignTripDataLoading,isSuccess:AssignTripDataLoadingIsuccess} = useGetAssign_To_Tripes({enable:true})
   const {data:OtherTripTypeData,isLoading:OthersTripTypeLoading,isSuccess:OthersTripTypeSuccess} = useGetOtersTripTypes({enable:true})


   const {mutate:addTerritoryTown} = useAddTerritoryTown() 
   const {mutate:UpadateTerritoryTown} = useUpdateTerritoryTown();
     const handleSubmit =(e:any)=>{
      e.preventDefault();

      if (!ModalData.Town) {
    showToast.warning("Town is required");
    return;
  }
  if (!ModalData.Assig_To_Trip_Type) {
     showToast.warning("Assign To Trip Type is required");
    return;
  }
  if (!ModalData.Other_Trip_Type) {
     showToast.warning("Other Trip Type is required");
    return;
  }

       
      if(checkAddEditStatus ==='Add'){   
       
        const reqBody={
           Itownid:Number(ModalData.Town),
           TerritoryId: Number(TerritoryId),
           AssignToTripType:ModalData.Assig_To_Trip_Type,
           OthersTripType:ModalData.Other_Trip_Type,
           OnlyNca:ModalData.Only_NCA
        }
        addTerritoryTown({ReqBody:reqBody},{onSuccess:()=>{
            setIsModalOpen(false);
        }});
        
      }
      else if(checkAddEditStatus ==='Edit'){
        const reqBody = {
            id: rowData.TerritoryTownsId,
            Itownid:Number(ModalData.Town),
            TerritoryId:Number(TerritoryId),
            AssignToTripType:ModalData.Assig_To_Trip_Type,
            OthersTripType:ModalData.Other_Trip_Type,
            OnlyNca: ModalData.Only_NCA
        }
        UpadateTerritoryTown({ReqBody:reqBody},{onSuccess:()=>{
            setIsModalOpen(false);
        }})
      }
    //   setModalData(initialModalData)
      
    //   setTownListInitalOption(null);
   }


    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen);setModalData(initialModalData);setTownListInitalOption(null)}}
            title={checkAddEditStatus == "Add" ? "Add Towns" : "Edit Towns"}
            size="sm"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0">
                    
                            <PaginatedRouteDropdown 
                               DropdownHeading='Town*'
                               initialSelectedOptions={TownListInitalOption}
                               onChange={(value:any)=>{
                                  setModalData((prev:any)=>({
                                    ...prev,
                                    Town:value.id
                                  }))
                               }}


                              fetchOptions={async(page:any,search:any)=>{
                                const res = await getTownFilter({
                                    search:search || '',
                                    page:1,
                                    limit:10,
                                }) 
                               const FD = Object.entries(res?.data?.TownsData ||{}).map(([key,value])=>({
                                id:Number(key),
                                label: String(value)
                                })) 
                                return FD;
                             }}
                            /> 

                             <ReusableDropdown
                                options={ (!AssignTripDataLoading && AssignTripDataLoadingIsuccess && AssignTripData) || []}
                                value={ModalData.Assig_To_Trip_Type}
                                onChange={(value: any) => setModalData((prev:any)=>({
                                    ...prev,
                                    Assig_To_Trip_Type:value
                                }))}
                                DropdownHeading="Assign to Trip Type*"
                            />
                            
                             <ReusableDropdown
                                options={(!OthersTripTypeLoading && OthersTripTypeSuccess && OtherTripTypeData) || []}
                                value={ModalData.Other_Trip_Type}
                                onChange={(value:any)=>setModalData((prev:any)=>({
                                    ...prev,
                                    Other_Trip_Type:value
                                }))}
                                DropdownHeading="Others Trip Type*"
                            />
                        
                        <div style={{ height: 10 }} />
                        <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-start', alignItems: 'baseline' }}>
                        <input type="checkbox" name="Only_NAC"  checked={ModalData.Only_NCA} onChange={(e)=>setModalData((prev:any)=>({
                            ...prev,
                            Only_NCA:e.target.checked
                        }))}/>
                        <label htmlFor="Only_NAC">Only NCA</label>
                        </div>

                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {checkAddEditStatus === 'Add' ? 'Submit' : 'Update'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => {setIsModalOpen(false); setCheckAddEditStatus('');setModalData(initialModalData);setTownListInitalOption(null) }}
                            >
                                Cancel
                            </Btn>
                        </div>
                    </div>
                </form>
            }
        />
    )
}

export default TownAddAndEditModal